import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer
      className="relative bg-[#0a0a0a] pt-24 lg:pt-32 pb-10 border-t border-[#c2a978]/15"
      data-testid="site-footer"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        {/* Massive brand line */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="mb-16 lg:mb-24"
        >
          <div className="text-[10vw] lg:text-[8vw] font-serif italic text-[#f5f5f0] leading-[0.9] tracking-[-0.02em]">
            Scorpion<span className="text-[#c2a978]">.</span>
          </div>
          <div className="mt-4 lg:-mt-2 text-[10px] tracking-[0.5em] uppercase text-[#c2a978]">
            Private Capital · Est. Discreet
          </div>
        </motion.div>

        {/* Columns */}
        <div className="grid grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8 pt-10 border-t border-[#c2a978]/10">
          <div className="col-span-2 lg:col-span-5">
            <p className="text-[#8a8a8a] text-sm lg:text-base leading-relaxed max-w-md">
              Scorpion Funding is a private capital group deploying working capital, revenue-based advances, and bridge financing to high-velocity operators across North America.
            </p>
            <a href="https://app.scorpionfunding.com" target="_blank" rel="noopener noreferrer" className="btn-gold mt-8">
              Begin Intake <ArrowUpRight size={16} />
            </a>
          </div>

          <FooterCol
            title="Capital"
            items={['Merchant Cash Advance', 'Equipment Financing', 'SBA Loans', 'HELOC', 'Invoice Factoring', 'Business Line of Credit']}
          />
          <FooterCol
            title="House"
            items={['Manifesto', 'Process', 'Voices', 'FAQ', 'Contact']}
          />
          <FooterCol
            title="Reach"
            items={['347-864-6712', 'Info@scorpionfunding.com', 'Miami · NYC · London']}
          />
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-[#c2a978]/10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div className="text-[10px] tracking-[0.35em] uppercase text-[#8a8a8a]">
            © {new Date().getFullYear()} Scorpion Funding LLC · All rights reserved
          </div>
          <div className="flex items-center gap-8 text-[10px] tracking-[0.35em] uppercase text-[#8a8a8a]">
            <a href="#" className="hover:text-[#c2a978] transition-colors">Privacy</a>
            <a href="#" className="hover:text-[#c2a978] transition-colors">Terms</a>
            <a href="#" className="hover:text-[#c2a978] transition-colors">Disclosures</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div className="lg:col-span-2 lg:col-start-auto">
      <div className="text-[10px] tracking-[0.4em] uppercase text-[#c2a978] mb-6">
        {title}
      </div>
      <ul className="space-y-3">
        {items.map((it) => (
          <li key={it}>
            <a
              href="#"
              className="text-sm text-[#f5f5f0]/80 hover:text-[#c2a978] transition-colors duration-300"
            >
              {it}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
